module.exports = __webpack_public_path__ + "static/media/acms_wiki.28061b24.svg";